<template>
	<section>
		<section class="order-main">
            <div class="content">
                <div class="order-filter">
                    <div class="hotel-name">
                       预约核销
                    </div>
                    <div class="filter-form">
                        <div class="filter-box-one">
                            <div class="filter-item">
                                <label class="item-title">预约码:</label>
                                <input class="item-input" type="text" v-model="QGOrderNo">
                            </div>
                        </div>
                        <div class="filter-box-one">
                            <div class="filter-item">
                                <label class="item-title">手机号:</label>
                                <input class="item-input" type="text" v-model="CustomerPhone">
                            </div>
                        </div>
                        <div class="filter-box-one">
                        	<div class="filter-item">
                                <label class="item-title">是否核销：</label>
                                <select class="item-select" v-model="IsWriteOff">
               						<option :value="true">是</option> 
               						<option :value="false">否</option>   
                                </select>
                            </div>
                        </div>
                        <div class="search-btn-one" @click="initData(1)">查询</div>
                    </div>
                    
                </div>
            </div>
        </section>
        <section class="order-content">
            <div class="content">
                <table class="order-table" cellspacing="0">
                    <thead>
                        <tr>
                            <td width="5%">序号</td>
                            <td width="10%">预约码</td>
                            <td class="box" width="65%">产品名称</td>
                            <td width="10%">手机号</td>
                            <td width="5%">是否核销</td>
                            <td width="5%">操作</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list">
                            <td>{{index+1}}</td>
                            <td>{{item.SubCode}}</td>
                            <td class="box-a">{{item.ProductName}}</td>
                            <td>{{item.CustomerPhone}}</td>
                            <td>{{item.IsUsed?'是':'否'}}</td>
                            <td class="box"><div class="check" @click="check(item)" v-if="!item.IsUsed">核销</div> </td>
                        </tr>
                      
                        
                    </tbody>
                    <tbody  v-if="!list||list.length<=0">
                        <tr>
                            <td colspan="7">没有相关数据</td>
                        </tr>
                    </tbody>
                </table>
               <div class="paging-list" v-if="list&&list.length>0">
                    <paginate
                        :page-count="pageCount"
                        :page-range="2"
                        :margin-pages="1"
                        :force-page="PageIndex"
                        :click-handler="initData"
                        :prev-text="'<<上一页'"
                        :next-text="'下一页>>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>
                    <span class="total-page">共{{pageCount}}页</span>
                    <div class="clear"></div>
                </div>
            </div>
        </section>
        <CheckBox :cData="cData" v-if="isCheckBoxShow" @close="isCheckBoxShow=false" @ok="create"></CheckBox>

	</section>
	
</template>
<script>
    import Paginate from 'vuejs-paginate'
    import CheckBox from './check.vue'
    export default {
        components:{
            Paginate,
            CheckBox
        },
        data() {
            return {
                userInfo:JSON.parse(this.dao.get('res')),
                isCheckBoxShow: false,
                list:'',
                QGOrderNo:'',
                CustomerPhone:'',
                SupplierNo:JSON.parse(this.dao.get('res')).userName,
                // SupplierNo:'',
                IsWriteOff:false,
                pageCount:0,
                PageIndex:1,
                cData:{}
            }
        },
        methods: {
            //获取预约核销列表
            initData(PageIndex){
                var that=this;
                that.PageIndex=PageIndex-1;
                var params={
                  QGOrderNo: that.QGOrderNo,
                  CustomerPhone: that.CustomerPhone,
                  SupplierNo: that.SupplierNo,
                  IsWriteOff: that.IsWriteOff,
                  PageIndex: PageIndex,
                  pageSize: 10,
                }
                that.getRequest({
                    url: that.Api.getLimitList,
                    params: params
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.list=res.Result;
                        that.pageCount=Math.ceil(res.Total/10);
                    }
                });
            },
            create(){
                this.isCheckBoxShow=false;
                this.initData(1);
            },
            check(item){
                this.cData=item;
                this.isCheckBoxShow=true;
            },
            showMask () {
                this.maskShow = true
            }
        },
        mounted(){
            this.initData(1);
       
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/veri/veri.vue